import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CardDocActionsComponent } from './card-doc-actions.component';
import { CardDocFooterComponent } from './card-doc-footer.component';
import { CardDocComponent } from './card-doc.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    CardDocComponent,
    CardDocFooterComponent,
    CardDocActionsComponent,
  ],
  exports: [CardDocComponent, CardDocFooterComponent, CardDocActionsComponent],
})
export class CardDocModule {}
